import React, { createContext, useCallback, useMemo, useState } from "react";
import { Invitation, Offer, PartyModel, RequestedListing } from "../types";

interface SelectedGroupContextData {
  selectedGroup: PartyModel | null;
  invitations: Invitation[];
  requestedListing: RequestedListing[];
  offers: Offer[];
  setSelectedGroup: (group: PartyModel | null) => void;
}

export const SelectedGroupContext = createContext<SelectedGroupContextData>({
  selectedGroup: null,
  invitations: [],
  requestedListing: [],
  offers: [],
  setSelectedGroup: () => {},
});

export const SelectedGroupProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selectedGroup, setSelectedGroupState] = useState<PartyModel | null>(null);

  const setSelectedGroup = useCallback((group: PartyModel | null) => {
    setSelectedGroupState(group);
  }, []);

  const value = useMemo(() => ({
    selectedGroup,
    invitations: selectedGroup?.invitations ?? [],
    requestedListing: selectedGroup?.requestedListings ?? [],
    offers: selectedGroup?.promotersOffers[0]?.offers ?? [],
    setSelectedGroup,
  }), [selectedGroup, setSelectedGroup]);

  return (
    <SelectedGroupContext.Provider value={value}>
      {children}
    </SelectedGroupContext.Provider>
  );
};
